import { Component, Input } from '@angular/core';

@Component({
    selector: 'lib-app-button',
    imports: [],
    templateUrl: './button.component.html',
    styleUrl: './button.component.scss'
})
export class ButtonComponent {
  @Input() label = '';
  @Input() className = '';
  @Input() disableButton = false;
  @Input() onClick: () => void = () => {};
}